import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SwiftCharacterSetComponent } from '@pg-app/common/swift-character-set/swift-character-set';
import { Regex } from '@pg-app/shared/constants/regex';

@Component({
    selector: 'np-swift-character-message',
    template: `
    <ng-container *ngIf="!fieldControl || !fieldControl.value?.match(newLineRegex)">
        Please only use characters admissable by SWIFT.
        For a list of valid characters click <span class="open-swift-set" (click)="openSWIFTCharacterSet()">here</span>.
    </ng-container>
    <ng-container *ngIf="fieldControl && fieldControl.value?.match(newLineRegex)">
        This field contained multiple lines in the input file. Please reenter as a single line.
    </ng-container>
    `,
})

export class SwiftCharacterMessageComponent {

    @Input() fieldControl: FormControl;
    newLineRegex = Regex.newLine;
    constructor(
        private dialog: MatDialog
    ) { }

    openSWIFTCharacterSet() {
        this.dialog.open(SwiftCharacterSetComponent);
    }
}

